import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Alert, AlertState } from './Alert';
import styles from './Alerts.module.scss';
import classNames from 'classnames';

export type AlertProps = {
	currentRoute: string;
	gutterTop?: true;
};

type InternalAlertState = AlertState & {
	triggerClose?: boolean;
	onExited?: () => void;
};

export const Alerts: React.FC<AlertProps> = ( { currentRoute, gutterTop } ) => {
	const [ alerts, setAlerts ] = useState<InternalAlertState[]>( [] );

	const alert: AlertState | undefined = useSelector(
		( state: any ) => state.alert.alert
	);

	useEffect( () => {
		if ( alert ) {
			if ( alert.isRemove ) {
				setAlerts( ( prevState ) => {
					if ( prevState.find( ( a ) => a.id === alert.id ) ) {
						const newState = [ ...prevState ];
						const index = newState.findIndex( ( a ) => a.id === alert.id );
						newState[ index ].triggerClose = true;
						return newState;
					} else {
						return prevState;
					}
				} );
			} else {
				setAlerts( ( prevState ) =>
					prevState.find( ( a ) => a.id === alert.id )
						? prevState
						: [ ...prevState, alert ]
				);
			}
		}
	}, [ alert ] );

	if ( alerts.length === 0 ) {
		return null;
	}

	return (
		<Box
			className={ classNames(
				styles.container,
				gutterTop ? styles.gutterTop : undefined
			) }
		>
			{ alerts.map( ( alert, index ) => (
				<Alert
					key={ alert.id }
					alert={ alert }
					currentRoute={ currentRoute }
					onExited={ () =>
						alert.triggerClose
							? setAlerts( ( prevState ) =>
								prevState.filter( ( a ) => a.id !== alert.id )
							  )
							: undefined
					}
					gutterTop={ gutterTop && index === 0 ? true : undefined }
					triggerClose={ alert.triggerClose ? true : undefined }
				/>
			) ) }
		</Box>
	);
};
